import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';

const HangupConfirmationModal = ({ isOpen, onCloseClick, onHangupClick, isLoading }) => {
  return (
    <Modal isOpen={isOpen} size="md" centered>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.PhoneOff size={60} className="text-danger" />
          <div className="fs-4 pt-2">Hang up this call?</div>
          <div className="fs-6 pt-2 text-center">
            This ends the live call now and notifies FreeSWITCH. This action cannot be undone.
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button
          onClick={onCloseClick}
          className="px-5 bg-transparent text-primary"
          disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={onHangupClick}
          className="px-5 bg-danger border-danger"
          disabled={isLoading}>
          {isLoading ? 'Hanging up...' : 'Hang up'}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

HangupConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func,
  onHangupClick: PropTypes.func,
  isLoading: PropTypes.bool
};

export default HangupConfirmationModal;
